import { useState, useEffect } from 'react';

/**
 * Custom hook to detect device type based on screen size
 * Returns true for desktop devices (>=968px), false for mobile/tablet
 */
export const useDeviceDetection = () => {
  const [isDesktop, setIsDesktop] = useState(true);

  useEffect(() => {
    const checkDevice = () => {
      // Check screen width - consider desktop if width >= 968px (tablet breakpoint)
      const isDesktopByWidth = window.innerWidth >= 968;
      
      // For simplicity, just use screen width as the primary indicator
      // Show download screen for tablets and mobile devices
      const isDesktopDevice = isDesktopByWidth;
      
      setIsDesktop(isDesktopDevice);
    };

    // Check on initial load
    checkDevice();

    // Add resize listener to handle device rotation or window resizing
    window.addEventListener('resize', checkDevice);

    // Cleanup
    return () => {
      window.removeEventListener('resize', checkDevice);
    };
  }, []);

  return isDesktop;
};
